import { GeneralResponse } from '../models/generalResponse'

export function notifyDesktop(messagesRepository, contextData, requestData) {
  return messagesRepository.notifyDesktop(contextData, requestData).then(data => new GeneralResponse(data));
}